<template>
    <div :class="field.templateOptions.wrapperClass">
        <label>{{field.templateOptions.label}}</label>
        <div class="text-secondary">
         <small><i class="fa fa-info-circle mr-1"></i>{{$t('imageUploader.warn')}}</small>
        </div>
        <v-uploader @done="uploadDone" upload-file-obj-name="file" :item-limit="1"
                    :upload-file-url="uploadUrl"
                    :delete-file-url="deleteUrl"
                    file-type-exts="jpeg,jpg,png"
                    file-size-limit="20MB"
                    language="en"
                    :previewImg="this.model[this.field.key]"
                    :class="field.templateOptions.class ? field.templateOptions.class : 'col-12'"></v-uploader>
    </div>
</template>

<script>
  import baseField from 'vue-formly-bootstrap/src/fields/baseField';
  import {API_ROOT} from '../../constants';

  export default {
    name: 'ImageField',
    mixins: [baseField],
    components: {
      vUploader: () => import('v-uploader/src/Uploader')
    },
    methods: {
      uploadDone(image) {
        if (image) {
          this.model[this.field.key] = image[0].url;
        }
      }
    },
    computed: {
      uploadUrl() {
        return API_ROOT + '/media/upload';
      },
      deleteUrl() {
        return  API_ROOT + '/media/upload';
      }
    }
  };
</script>

<style scoped>

</style>
